<template>
  <HeaderWithFilter
      title="Dashboard"
      :go-back="()=>null"/>
  <AnalyticDashboard/>
  <DashboardBVHeader title="Vervoersopdrachten" @click="goToBvDetail(true)" :is-main='true' class="mt-8" style="cursor: pointer;" />
<!--  <DashboardBVHeader title="BV's met meeste omzet" :is-main='false' class="mt-8"/>

  <section class="bv-section">
    <div class="">
      <div class="cd-section">
        <Carousel
            @slide-end="onSlideOzmet"
            ref="myCarouselOzmet"
            v-model="currentSlideOzmet"
            :items-to-show="itemsToShow"
            :wrapAround="false"
            :vertical="false"
            :snap-align="'start'"
            :transition="1000"
            class="company-views-carousel"
        >
          <Slide class="grid-container" v-for="(bv, index) in businessViewsOzmet" :style="{ marginLeft: index === 0 ? '16px' : '0' }">
            <div class="mr-5">
              <DashboardBvCard
                  :costs-percentage-change="bv.costsPercentageChange"
                  :profit-percentage-change="bv.profitPercentageChange"
                  :revenue-percentage-change="bv.revenuePercentageChange"
                  :profit-loss="bv.profitLoss"
                  :costs="bv.costs"
                  :revenue="bv.revenue"
                  :haveDetail="bv.haveDetail"
                  @click="goToBvDetail(bv.haveDetail)"
                  :name="bv.name"/>
            </div>
          </Slide>
        </Carousel>

      </div>
      <PaginationControls
          @update:modelValue="changePageOzmet"
          :page-change="changePageOzmet"
          v-model="currentPageOzmet"
          :totalPages="totalPagesOzmet"
      />
    </div>
  </section>
  <DashboardBVHeader title="BV's met meeste winst" :is-main='false' class="mt-8"/>

  <section class="bv-section">
    <div class="">
      <div class="cd-section">
        <Carousel
            @slide-end="onSlideWinst"
            ref="myCarouselWinst"
            v-model="currentSlideWinst"
            :items-to-show="itemsToShow"
            :wrapAround="false"
            :vertical="false"
            :snap-align="'start'"
            :transition="1000"
            class="company-views-carousel"
        >
          <Slide class="grid-container" v-for="(bv, index) in businessViewsWinst" :style="{ marginLeft: index === 0 ? '16px' : '0' }">
            <div class="mr-5">
              <DashboardBvCard
                  :costs-percentage-change="bv.costsPercentageChange"
                  :profit-percentage-change="bv.profitPercentageChange"
                  :revenue-percentage-change="bv.revenuePercentageChange"
                  :profit-loss="bv.profitLoss"
                  :costs="bv.costs"
                  :haveDetail="bv.haveDetail"
                  :revenue="bv.revenue"
                  @click="goToBvDetail(bv.haveDetail)"
                  :name="bv.name"/>
            </div>
          </Slide>
        </Carousel>

      </div>
      <PaginationControls
          @update:modelValue="changePageWinst"
          :page-change="changePageWinst"
          v-model="currentPageWinst"
          :totalPages="totalPagesWinst"
      />
    </div>
  </section>
  <DashboardBVHeader title="BV's met meest verlies" :is-main='false' class="mt-8"/>

  <section class="bv-section">
    <div class="">
      <div class="cd-section">
        <Carousel
            @slide-end="onSlideVerlies"
            ref="myCarouselVerlies"
            v-model="currentSlideVerlies"
            :items-to-show="itemsToShow"
            :wrapAround="false"
            :vertical="false"
            :snap-align="'start'"
            :transition="1000"
            class="company-views-carousel"
        >
          <Slide class="grid-container" v-for="(bv, index) in businessViewsVerlies" :style="{ marginLeft: index === 0 ? '16px' : '0' }">
            <div class="mr-5">
              <DashboardBvCard
                  :costs-percentage-change="bv.costsPercentageChange"
                  :profit-percentage-change="bv.profitPercentageChange"
                  :revenue-percentage-change="bv.revenuePercentageChange"
                  :profit-loss="bv.profitLoss"
                  :costs="bv.costs"
                  :haveDetail="bv.haveDetail"
                  :revenue="bv.revenue"
                  @click="goToBvDetail(bv.haveDetail)"
                  :name="bv.name"/>
            </div>
          </Slide>
        </Carousel>

      </div>
      <PaginationControls
          @update:modelValue="changePageVerlies"
          :page-change="changePageVerlies"
          v-model="currentPageVerlies"
          :totalPages="totalPagesVerlies"
      />
    </div>
  </section>-->
</template>

<style>


.bv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
}

.bv-grid-item {
  width: 100%;
}

.business-views-carousel {
  text-align: start;
  display: flex;
  flex-direction: column;
  width: 100%;
}


.filter-icon {
  aspect-ratio: 1;
  width: 24px;
}

.dashboard-container {
  display: flex;
  margin-top: 16px;
  width: 100%;
  align-items: center;
  gap: 40px 100px;
  justify-content: space-between;
  flex-wrap: wrap;
}

@media (max-width: 991px) {
  .dashboard-container {
    max-width: 100%;
  }
}

.bv-section {
  width: 90vw;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
</style>


<script setup lang="ts">
import HeaderWithFilter from './HeaderWithFilter.vue';
import {Carousel, type CarouselMethods, type CarouselNav, Navigation, Pagination, Slide} from 'vue3-carousel';
import DashboardBvCard from './cards/DashboardBvCard.vue';
import DashboardBVHeader from './DashboardBVHeader.vue';
import type {BusinessView} from './types';
import 'vue3-carousel/dist/carousel.css';
import '@vuepic/vue-datepicker/dist/main.css';
import PaginationControls from "../components/PaginationControls.vue";
import {onMounted, onUnmounted, ref} from "vue";
import router from '../router';
import AnalyticDashboard from "../components/AnalyticDashboard.vue";
import {getFinancialData, FinancialResponse, financialResponse} from "../composables/getFinancial";
const changePageOzmet = (page: number) => {
  console.log("page changed to "+page)
  myCarouselOzmet?.value?.slideTo(itemsToShow.value * (page - 1));
  currentPageOzmet.value = page
}
const changePageVerlies = (page: number) => {
  console.log("page changed to "+page)
  myCarouselVerlies?.value?.slideTo(itemsToShow.value * (page - 1));
  currentPageVerlies.value = page
}
const changePageWinst = (page: number) => {
  console.log("page changed to "+page)
  myCarouselWinst?.value?.slideTo(itemsToShow.value * (page - 1));
  currentPageWinst.value = page
}
const myCarouselOzmet = ref<CarouselMethods>();
const myCarouselWinst = ref<CarouselMethods>();
const myCarouselVerlies = ref<CarouselMethods>();
const itemsToShow = ref(1);


const updateItemsToShow = () => {
  const containerWidth =
      document.querySelector('.company-views-carousel')?.clientWidth || 0;
  const itemWidth = 260; // Fixed item width
  itemsToShow.value = Math.floor(containerWidth / itemWidth);
  totalPagesOzmet = Math.ceil(businessViewsOzmet.length / itemsToShow.value)
  totalPagesVerlies = Math.ceil(businessViewsVerlies.length / itemsToShow.value)
  totalPagesWinst = Math.ceil(businessViewsWinst.length / itemsToShow.value)
};
let now=new Date();
let prevMonth = new Date();
prevMonth.setMonth(now.getMonth() - 1);
let sencondMonth = new Date();
sencondMonth.setMonth(now.getMonth() - 2);
// Update on window resize
onMounted(() => {
  getFinancialData().then((data) => {
    console.log("received data")
    console.log(data)
    financialResponse.value = data;
  });
  updateItemsToShow();
  window.addEventListener('resize', updateItemsToShow);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateItemsToShow);
});
const goToBvDetail = (haveDetail:Boolean) => {
  if(haveDetail)
    router.push({ name: 'bvDetail' });
};
let currentPageOzmet = ref(1)
let currentPageWinst = ref(1)
let currentPageVerlies = ref(1)

const onSlideOzmet = (value: any) => {
  currentPageOzmet.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
const onSlideWinst = (value: any) => {
  currentPageWinst.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
const onSlideVerlies = (value: any) => {
  currentPageVerlies.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
let currentSlideOzmet = 0
let currentSlideWinst = 0
let currentSlideVerlies = 0
let businessViewsOzmet =Array.from({length:60},(_,i)=>{
  return {
    id: i,
    name: 'BV naam '+i,
    revenue: 3042.22,
    costs: 3042.22,
    profitLoss: 3042.22,
    isTopBV: false,
    haveDetail:i%3!=0,
    revenuePercentageChange: 14,
    costsPercentageChange: 14,
    profitPercentageChange: 14
  }
}) as BusinessView[]
let businessViewsWinst =Array.from({length:60},(_,i)=>{
  return {
    id: i,
    name: 'BV naam '+i,
    haveDetail:i%3!=0,
    revenue: 3042.22,
    costs: 3042.22,
    profitLoss: 3042.22,
    isTopBV: false,
    revenuePercentageChange: 14,
    costsPercentageChange: 14,
    profitPercentageChange: 14
  }
}) as BusinessView[]
let businessViewsVerlies =Array.from({length:60},(_,i)=>{
  return {
    id: i,
    name: 'BV naam '+i,
    revenue: 3042.22,
    haveDetail:i%3!=0,
    costs: 3042.22,
    profitLoss: 3042.22,
    isTopBV: false,
    revenuePercentageChange: 14,
    costsPercentageChange: 14,
    profitPercentageChange: 14
  }
}) as BusinessView[]

let totalPagesOzmet = Math.ceil(businessViewsOzmet.length / itemsToShow.value)
let totalPagesWinst = Math.ceil(businessViewsWinst.length / itemsToShow.value)
let totalPagesVerlies = Math.ceil(businessViewsVerlies.length / itemsToShow.value)

</script>
